import {HttpClient} from "../../http/HttpClient.jsx";

export const validateCreditCard = async (creditCardNumber, expiryMonth, expiryYear, cvv) => {
    return HttpClient.safePost(`/api/events/payment/credit/validation`, {
        creditCardNumber,
        expiryMonth,
        expiryYear,
        cvv
    });
};
